"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_NAMES = void 0;
exports.ERROR_NAMES = {
    AUTH_CHALLENGE_CODE_EXPIRED_ERROR: 'AuthChallengeCodeExpiredError',
    AUTH_CHALLENGE_CODE_INCORRECT_ERROR: 'AuthChallengeCodeIncorrectError',
    AUTH_CHALLENGE_TOO_MANY_ATTEMPTS_ERROR: 'AuthChallengeTooManyAttemptsError',
    AUTH_CHALLENGE_TOO_MANY_FAILURES_ERROR: 'AuthChallengeTooManyFailuresError',
    BAD_CRON_EVENT_REQUEST_ERROR: 'BadCronEventRequestError',
    BAD_QUEUE_EVENT_REQUEST_ERROR: 'BadQueueEventRequestError',
    BAD_REQUEST_ERROR: 'BadRequestError',
    COULD_NOT_GENERATE_JWT_ERROR: 'CouldNotGenerateJwtError',
    FORBIDDEN_ERROR: 'ForbiddenError',
    NON_PRODUCTION_EMAIL_ERROR: 'NonProductionEmailError',
    SEND_BIRD_NOT_ENABLED_ERROR: 'SendbirdNotEnabledError',
    NON_PRODUCTION_NOTIFICATION_ERROR: 'NonProductionNotificationError',
    NON_PRODUCTION_TEXT_ERROR: 'NonProductionTextError',
    NO_PROPERTY_FOUND_ERROR: 'NoPropertyFoundError',
    NOT_FOUND_ERROR: 'NotFoundError',
    OPEN_AI_ERROR: 'OpenAIError',
    SEND_EMAIL_TO_OPTED_OUT_USER_ERROR: 'SendEmailToOptedOutUserError',
    SEND_PUSH_TO_OPTED_OUT_USER_ERROR: 'SendPushToOptedOutUserError',
    SEND_TEXT_TO_OPTED_OUT_USER_ERROR: 'SendTextToOptedOutUserError',
    UNAUTHORIZED_ERROR: 'UnauthorizedError',
    USER_INVITE_ALREADY_ACCEPTED_ERROR: 'UserInvitationAlreadyAcceptedError',
    USER_INVITATION_CANCELED_ERROR: 'UserInvitationCanceledError',
    USER_INVITATION_EXPIRED_ERROR: 'UserInvitationExpiredError',
    USER_NOT_FOUND: 'UserNotFoundError',
    VIDEO_SIZE_ERROR: 'VideoSizeError',
    VIDEO_TYPE_ERROR: 'VideoTypeError',
};
//# sourceMappingURL=error.types.js.map